import ClientService from '../../../../services/client-service';
import getUserVerificationSetupDataQuery from '../../../../graphql/query/get-user-verification-setup-data.graphql';
import sendPhoneVerificationCodeSetupMutation
  from '../../../../graphql/mutation/send-phone-verification-code-setup.graphql';
import verifyUserPhoneSetupMutation from '../../../../graphql/mutation/verify-user-phone-setup.graphql';
import generateOtpSecretDataSetupMutation from '../../../../graphql/mutation/generate-otp-secret-data-setup.graphql';
import verifyUserOtpSetupMutation from '../../../../graphql/mutation/verify-user-otp-setup.graphql';
import deleteOtpSecretDataSetupMutation from '../../../../graphql/mutation/delete-otp-secret-data-setup.graphql';
import saveUserVerificationDataMutation from '../../../../graphql/mutation/save-user-verification-data.graphql';

export default class VerificationSetupApi {
  public static getUserVerificationSetupData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getUserVerificationSetupDataQuery, payload);
  }

  public static sendPhoneVerificationCodeSetup(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(sendPhoneVerificationCodeSetupMutation, payload);
  }

  public static verifyUserPhoneSetup(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(verifyUserPhoneSetupMutation, payload);
  }

  public static generateOtpSecretDataSetup(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(generateOtpSecretDataSetupMutation, payload);
  }

  public static verifyUserOtpSetup(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(verifyUserOtpSetupMutation, payload);
  }

  public static deleteOtpSecretDataSetup(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteOtpSecretDataSetupMutation, payload);
  }

  public static saveUserVerificationData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveUserVerificationDataMutation, payload);
  }
}
